import SEO from "components/SEO";
import Signin from "components/Signin";
import React from "react";
import useTranslation from "translations/hooks/useTranslation";

export default function Login() {
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("signIn")} description={t("signIn")} />
      <Signin introSentence={t("signinSentence")} />
    </>
  );
}

Login.options = {
  allow: ["guest"],
  redirectTo: { href: "/", as: "/" },
};
